module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-wrap clearFloat"
  }, _vm._l((_vm.results.data), function(video, index) {
    return _c('div', {
      staticClass: "singleVideoBox",
      attrs: {
        "data-id": video.videoID
      }
    }, [_c('a', {
      staticClass: "video-link",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.openPage(video.webUrl)
        },
        "mouseenter": _vm.startPlayVideo,
        "mouseleave": _vm.stopPlayVideo
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (video.imgObj),
        expression: "video.imgObj"
      }],
      staticClass: "videoConBox"
    }), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.openPage(video.webUrl)
        },
        "mouseenter": _vm.startPlayVideo,
        "mouseleave": _vm.stopPlayVideo
      }
    }, [_c('div', {
      staticClass: "videoInfoBox"
    }, [_c('span', {
      staticClass: "videoText"
    }, [_vm._v(_vm._s(video.source))]), _vm._v(" "), _c('span', {
      staticClass: "videoText"
    }, [_vm._v(_vm._s(video.time))])])]), _vm._v(" "), _c('div', {
      staticClass: "videoInfoTitle"
    }, [_c('a', {
      staticClass: "text-title",
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "title": video.webTitle,
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.openPage(video.webUrl)
        }
      }
    }, [_c('p', {
      staticClass: "videoSubtit",
      domProps: {
        "innerHTML": _vm._s(video.webTitleFormat)
      }
    })]), _vm._v(" "), (!video.hasAction) ? _c('div', {
      staticClass: "videoIsSave"
    }, [_vm._v(_vm._s(video.statusDesc))]) : _vm._e(), _vm._v(" "), (video.hasAction) ? _c('div', {
      staticClass: "videoNotSave",
      on: {
        "click": function($event) {
          _vm.saveEvidence(index)
        }
      }
    }, [_vm._v("存证")]) : _vm._e()])])
  }))
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play-btn",
    staticStyle: {
      "border-radius": "50%"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/search/triangle.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40676971"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/results/VideoResults.vue
// module id = 763
// module chunks = 1